/*!
 * Copyright (c) Conn Selmer Inc.
 * Class returns a formatted Brand Logo based on text input
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * GetBrandLogo Input Action
 *
 * brandShortName:string => The shorthand name of the brand. IE: bach, ludwig, scherl
 * - Compound names are truncated to their first name only
 * colorCode:number => a numeric code used to attach CSS values.
 * - IE: 0 == black, 1 == white, 2 == custom color, ...
 */
export class GetBrandLogoInput implements Msdyn365.IActionInput {
    public brandShortName: string;
    public colorCode: number;

    constructor(brandShortName: string, colorCode: number|string|null){
        this.brandShortName = brandShortName;
        if(colorCode !== null){
            this.colorCode = typeof colorCode === 'string' ? parseInt(colorCode, 10) : colorCode;
        } else {
            this.colorCode = 0;
        }
    }

    public getCacheKey = () => `${this.brandShortName}-${this.colorCode}`;
    public getCacheObjectType = () => 'BrandLogo';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetBrandLogoData {
    text: string;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    /*return new GetBrandLogoInput(brandShortName, colorCode);*/
    return new GetBrandLogoInput('bach', 0);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetBrandLogoInput, ctx: Msdyn365.IActionContext): Promise<IGetBrandLogoData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    // TODO: Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<IGetBrandLogoData[]>('/get/example/id/1', 'get');
    return { text: 'Static data from action' };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetBrandLogoData>>action,
    id: 'GetBrandLogo',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
